import axios from "axios";
import type { IWork, IWorkTitleSummary } from "containers/Works/types";
import { useEffect, useState } from "react";

export function useWorkTitles(workId?: number | null) {
    const [titles, setTitles] = useState<IWorkTitleSummary[]>([]);
    const [workName, setWorkName] = useState("");
    const [workAvatarUrl, setWorkAvatarUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(Boolean(workId));

    useEffect(() => {
        if (!workId) {
            setTitles([]);
            setWorkName("");
            setWorkAvatarUrl(null);
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);
        axios
            .get<{ data: IWork }>(`${import.meta.env.REACT_APP_API_ENDPOINT}/work/${workId}`)
            .then((response) => {
                if (cancelled) return;
                setTitles(response.data.data?.titles ?? []);
                setWorkName(response.data.data?.name ?? "");
                setWorkAvatarUrl(response.data.data?.avatarUrl ?? null);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [workId]);

    return { titles, workName, workAvatarUrl, isLoading };
}
